import React, { useEffect } from 'react';
import "react-perfect-scrollbar/dist/css/styles.css";
import InnerBanner from './innerBanner';
import PerfectScrollbar from "react-perfect-scrollbar";

const Pricing = ({ content, location, scrollToTag }) => {
    // When the component loads (or url location hash changes) scrolling to the appropriate tag
    useEffect(() => {
        scrollToTag(location);
    }, [scrollToTag, location]);

    return (
        <div className='pricing-pg'>

            {/* inner-banner section start */}
            <InnerBanner
                banner_image={content && content.banner_image}
                banner_title={content && content.banner_title}
                banner_cta_button={content && content.banner_cta_buttons}
                banner_info={content && content.banner_content}
                banner_disclaimer={content && content.banner_disclaimer} 
                tabChange={scrollToTag}
            />
            {/* inner-banner section end */}

            {/* pricing table section start */}
            {
                !!content.pricing_details.length && content.pricing_details.map((obj, index) => {
                    return (
                        <React.Fragment key={index}>
                            <div className="pricingtable-box" id={index === 0 ? "personal-price" : "business-price"} >
                                <div className="container">
                                    <div className="row-wrap">
                                        <div className="box-12 heading-box">
                                            <div className="inner-box">
                                                <h2 className="heading">{obj.title}</h2>
                                            </div>
                                        </div>
                                        <div className="box-12 pricelist">
                                            <div className="inner-box">
                                                <PerfectScrollbar
                                                    component='div'
                                                    // className="slideBg"
                                                    options={{
                                                        wheelSpeed: 0.8,
                                                        wheelPropagation: true,
                                                        minScrollbarLength: 20,
                                                        swipeEasing: true,
                                                        handlers: ["click-rail", "drag-thumb", "keyboard", "wheel", "touch"],
                                                    } }>
                                                    <div dangerouslySetInnerHTML={ { __html: obj.price_content } }></div>
                                                </PerfectScrollbar>
                                            </div>


                                        </div>
                                        <div className="box-12 button-box text-center">
                                            <div className="inner-box">
                                                <p dangerouslySetInnerHTML={{ __html: obj.more_info }}></p>
                                                {
                                                    obj.cta_button &&
                                                    <a href={obj.cta_button.url}
                                                        target={obj.cta_button.target !== "" ? "_blank" : "_self"}
                                                        rel="noreferrer"

                                                        className='button button-solid big-size'>
                                                        {obj.cta_button.title}
                                                    </a>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {
                                index === 0 && content.pricing_details.length > 1 &&
                                <div className="divider-box" style={ { 'height': '3px' } }>
                                    <span className="line"></span>
                                </div>
                            }
                        </React.Fragment >
                    );
                })
            }

        </div >
        // <Dummy />
    );
};

// const Dummy = props => {
//     return (<div>
//         <div className="pricingtable-box" id="personal-price">
//             <div className="container">
//                 <div className="row-wrap">
//                     <div className="box-12 heading-box">
//                         <div className="inner-box">
//                             <h2 className="heading">Personal Account Pricing</h2>
//                         </div>
//                     </div>
//                     <div className="box-12 pricelist">
//                         <div className="inner-box">
//                             {/* <div className="borderList">
//                                 <span className="noBorder"></span>
//                                 <span></span>
//                                 <span></span>
//                                 <span></span>
//                             </div> */}
//                             <PerfectScrollbar
//                                 component='div'

//                                 options={{
//                                     wheelSpeed: 0.8,
//                                     wheelPropagation: true,
//                                     minScrollbarLength: 20,
//                                     swipeEasing: true,
//                                     handlers: ["click-rail", "drag-thumb", "keyboard", "wheel", "touch"],
//                                 }}>

//                                 <table className="pricelist-table">
//                                     <thead>
//                                         <tr>
//                                             <th>MAINTAINING THE PAYMENT ACCOUNT</th>
//                                             <th>EEA</th>
//                                             <th>Non-EEA</th>
//                                             <th>Company representative</th>
//                                         </tr>
//                                     </thead>
//                                     <tbody>


//                                         <tr>
//                                             <td>Document identification and verification fee</td>
//                                             <td>Free</td>
//                                             <td>50 EUR</td>
//                                             <td>Free</td>
//                                         </tr>

//                                         <tr>
//                                             <td>Active Payment account maintenance (per month)</td>
//                                             <td>10 EUR</td>
//                                             <td>30 EUR</td>
//                                             <td>Free</td>
//                                         </tr>

//                                         <tr>
//                                             <td>Closing of Payment account</td>
//                                             <td>Free</td>
//                                             <td>Free</td>
//                                             <td>Free</td>
//                                         </tr>

//                                     </tbody>
//                                     <thead>
//                                         <tr>
//                                             <th>Payments</th>
//                                             <th></th>
//                                             <th></th>
//                                             <th></th>
//                                         </tr>
//                                     </thead>
//                                     <tbody>

//                                         <tr>
//                                             <td>Transfers between own DEMIVOLT Payment accounts</td>
//                                             <td>Free</td>
//                                             <td>Free</td>
//                                             <td>Free</td>
//                                         </tr>
//                                         <tr>
//                                             <td>Internal transfers within DEMIVOLT Payment accounts</td>
//                                             <td>Free</td>
//                                             <td>Free</td>
//                                             <td>Free</td>
//                                         </tr>
//                                         <tr>
//                                             <td>Incoming SEPA to a client Payment account</td>
//                                             <td>Free</td>
//                                             <td>5 EUR</td>
//                                             <td>5 EUR</td>
//                                         </tr>
//                                         <tr>
//                                             <td>Outgoing SEPA payments </td>
//                                             <td>5 EUR</td>
//                                             <td>10 EUR</td>
//                                             <td>10 EUR</td>
//                                         </tr>
//                                         <tr>
//                                             <td>Incoming SWIFT payments in EUR Currency*** </td>
//                                             <td>0.5% from the amount (min. 30 EUR)</td>
//                                             <td>1% from the amount (min. 50 EUR)</td>
//                                             <td>1% from the amount (min. 50 EUR)</td>
//                                         </tr>
//                                         <tr>
//                                             <td>Outgoing SWIFT payments in EUR Currency*** </td>
//                                             <td>0.5% from the amount (min. 50 EUR)</td>
//                                             <td>1% from the amount (min. 75 EUR)</td>
//                                             <td>1% from the amount (min. 75 EUR)</td>
//                                         </tr>
//                                         <tr>
//                                             <td>Forced write-off (PLAIS fee)</td>
//                                             <td>5 EUR</td>
//                                             <td>10 EUR</td>
//                                             <td>UR</td>
//                                         </tr>

//                                     </tbody>
//                                 </table>



//                             </PerfectScrollbar>
//                         </div>


//                     </div>
//                     <div className="box-12 button-box text-center">
//                         <div className="inner-box">
//                             <p>The full pricing list can be found <a href="#">here</a>.</p>
//                             <a href="#" className='button button-solid big-size'>Open an account</a>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div>

//         <div className="divider-box" style={{ 'height': '3px' }}>
//             <span className="line"></span>
//         </div>

//         <div className="pricingtable-box" id="business-price">
//             <div className="container">
//                 <div className="row-wrap">
//                     <div className="box-12 heading-box">
//                         <div className="inner-box">
//                             <h2 className="heading">Business Account Pricing</h2>
//                         </div>
//                     </div>
//                     <div className="box-12 pricelist">
//                         <div className="inner-box">
//                             <PerfectScrollbar
//                                 component='div'
//                                 // className="slideBg"
//                                 options={{
//                                     wheelSpeed: 0.8,
//                                     wheelPropagation: true,
//                                     minScrollbarLength: 20,
//                                     swipeEasing: true,
//                                     handlers: ["click-rail", "drag-thumb", "keyboard", "wheel", "touch"],
//                                 }}>

//                                 <table className="pricelist-table">
//                                     <thead>
//                                         <tr>
//                                             <th>MAINTAINING THE PAYMENT ACCOUNT</th>
//                                             <th>EEA Low/Medium-Risk</th>
//                                             <th>EEA High-Risk</th>
//                                             <th>Non-EEA Low/Medium-Risk</th>
//                                             <th>Non-EEA High-Risk</th>
//                                         </tr>
//                                     </thead>
//                                     <tbody>


//                                         <tr>
//                                             <td>Document identification and verification fee</td>
//                                             <td>200 EUR</td>
//                                             <td>1500 EUR</td>
//                                             <td>1000 EUR</td>
//                                             <td>2000 EUR</td>
//                                         </tr>

//                                         <tr>
//                                             <td>Active Payment account maintenance (per month)</td>
//                                             <td>50 EUR</td>
//                                             <td>350 EUR</td>
//                                             <td>200 EUR</td>
//                                             <td>450 EUR</td>
//                                         </tr>

//                                         <tr>
//                                             <td>Closing Payment account</td>
//                                             <td>Free</td>
//                                             <td>Free</td>
//                                             <td>Free</td>
//                                             <td>Free</td>
//                                         </tr>
//                                         <tr>
//                                             <td>Document identification and verification fee</td>
//                                             <td>200 EUR</td>
//                                             <td>1500 EUR</td>
//                                             <td>1000 EUR</td>
//                                             <td>2000 EUR</td>
//                                         </tr>

//                                         {/* <tr>
//                                             <td>Fee for holding funds on an Account (annual interest rate)
//                                                 <ul>
//                                                     <li>- up to EUR 100 000</li>
//                                                     <li>- over EUR 100 000</li>
//                                                 </ul>
//                                             </td>
//                                             <td>
//                                                 <ul>
//                                                     <li>0.5%</li>
//                                                     <li>1.0%</li>
//                                                 </ul>
//                                             </td>
//                                             <td>
//                                                 <ul>
//                                                     <li>0.5%</li>
//                                                     <li>1.0%</li>
//                                                 </ul>
//                                             </td>
//                                         </tr> */}

//                                     </tbody>
//                                     <thead>
//                                         <tr>
//                                             <th>Payments</th>
//                                             <th></th>
//                                             <th></th>
//                                             <th></th>
//                                             <th></th>
//                                         </tr>
//                                     </thead>
//                                     <tbody>

//                                         <tr>
//                                             <td>Transfers between own DEMIVOLT Payment accounts</td>
//                                             <td>Free</td>
//                                             <td>Free</td>
//                                             <td>Free</td>
//                                             <td>Free</td>
//                                         </tr>

//                                         <tr>
//                                             <td>Internal transfers within DEMIVOLT Payment accounts</td>
//                                             <td>Free</td>
//                                             <td>Free</td>
//                                             <td>Free</td>
//                                             <td>Free</td>
//                                         </tr>

//                                         <tr>
//                                             <td>Incoming/Outgoing SEPA to a Payment account (EUR)/ or PLAIS write-offs:</td>
//                                             <td></td>
//                                             <td></td>
//                                             <td></td>
//                                             <td></td>
//                                         </tr>

//                                         <tr>
//                                             <td>0.01 - 5000.00</td>
//                                             <td>5 EUR</td>
//                                             <td>0.15% from the amount (min. 10 EUR)</td>
//                                             <td>0.15% from the amount (min. 10 EUR)</td>
//                                             <td>0.5% from the amount (min. 20 EUR)</td>
//                                         </tr>
//                                         <tr>
//                                             <td>5000.01 - 50000.00</td>
//                                             <td>10 EUR</td>
//                                             <td>0.1% from the amount (min. 25 EUR)</td>
//                                             <td>0.1% from the amount (min. 25 EUR)</td>
//                                             <td>0.3% from the amount (min. 40 EUR)</td>
//                                         </tr>

//                                         <tr>
//                                             <td>50000.01-100000.00</td>
//                                             <td>25 EUR</td>
//                                             <td>0.05% from the amount (min. 40 EUR)</td>
//                                             <td>0.05% from the amount (min. 40 EUR)</td>
//                                             <td>0.15% from the amount (min. 80 EUR)</td>
//                                         </tr>
//                                         <tr>
//                                             <td>100 000.01+</td>
//                                             <td>50 EUR</td>
//                                             <td>0.05% from the amount (min. 75 EUR)</td>
//                                             <td>0.05% from the amount (min. 75 EUR)</td>
//                                             <td>0.1% from the amount</td>
//                                         </tr>

//                                         <tr>
//                                             <td>Incoming/Outgoing SWIFT Payments in EUR Currency***</td>
//                                             <td></td>
//                                             <td></td>
//                                             <td></td>
//                                             <td></td>
//                                         </tr>

//                                         <tr>
//                                             <td>0.01 - 5000.00</td>
//                                             <td>40 EUR</td>
//                                             <td>1% from the amount (min. 50 EUR)</td>
//                                             <td>1% from the amount (min. 50 EUR)</td>
//                                             <td>1% from the amount (min. 50 EUR)</td>
//                                         </tr>
//                                         <tr>
//                                             <td>5000.01 - 50000.00</td>
//                                             <td>0.3% from the amount (min. 50 EUR)</td>
//                                             <td>0.8% from the amount (min. 65 EUR)</td>
//                                             <td>0.8% from the amount (min. 65 EUR)</td>
//                                             <td>0.8% from the amount (min. 65 EUR)</td>
//                                         </tr>

//                                         <tr>
//                                             <td>50000.01-100000.00</td>
//                                             <td>0.25% from the amount (min. 80 EUR)</td>
//                                             <td>0.5% from the amount (min. 250 EUR)</td>
//                                             <td>0.5% from the amount (min. 250 EUR)</td>
//                                             <td>0.5% from the amount (min. 250 EUR)</td>
//                                         </tr>
//                                         <tr>
//                                             <td>100 000.01+</td>
//                                             <td>0.2% from the amount (min. 200 EUR)</td>
//                                             <td>0.3% from the amount (min. 300 EUR)</td>
//                                             <td>0.3% from the amount (min. 300 EUR)</td>
//                                             <td>0.3% from the amount (min. 300 EUR)</td>
//                                         </tr>

//                                     </tbody>
//                                 </table>

//                             </PerfectScrollbar>
//                         </div>
//                     </div>
//                     <div className="box-12 button-box text-center">
//                         <div className="inner-box">
//                             <p>The full pricing list can be found <a href="#">here</a>.</p>
//                             <a href="#" className='button button-solid big-size'>Open an account</a>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     </div>)
// };

export default Pricing;